import "./PerformanceSearchBar.css";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { useEffect } from "react";
import { useState } from "react";
import { BASE_URL, GLOBAL_SEARCH } from "utilFunctions/Constants/urlConstants";
import SearchBar from "utilFunctions/shared/GlobalSearchBar/SearchBar";
export interface selectInterface {
  label: any;
  key: any;
  value: any;
  region?: any;
  regionCode?: any;
  id?: any;
}

export const nullOption = [{ label: "All", key: "all", value: null }];
interface MultiSearchBarIF {
  onRequestClose?: any;
}
const MultiSearchBar = ({ onRequestClose }: MultiSearchBarIF) => {
  const [searchName, setSearchName] = useState<any>();
  const [suggestions, setSuggestions] = useState<any>([]);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [limit] = useState<number>(10);
  const [offset, setOffSet] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [searchURL, setSearchURL] = useState<string>("");
  const [selectedCategory, setSelectedCategory] = useState<string>("Student");
  const [input, setInput] = useState("");
  const [selectedItem, setselectedItem] = useState<any>({
    label: "Student",
    value: "student",
  });
  const { makeRequest: GetSearchData, responseData: searchData } = useGetApi(
    (data) => {
      onFetcheddata(data);
    },
    (error) => {
      onFetchError(error);
    }
  );
  const onFetcheddata = (data: any) => {
    setIsLoader(false);
    console.log(data);
  };
  const onFetchError = (error: any) => {
    console.log("erorr", error);
    setIsLoader(false);
    if (offset == 0) {
      // setSuggestions([]);
    } else {
      setOffSet(0);
    }
    setHasMore(false);
  };

  const routeToFaculty = (item: any) => {
    // navigate("/admin/faculties/" + item?.id, {
    //   replace: false,
    //   state: {
    //     faculty: item,
    //   },
    // });
    console.log(item);
    setSuggestions([]);
    setInput("");
  };

  const onClickHandler = (user: any) => {
    if (user?.employeeId && user?.employeeId != null) {
      routeToFaculty(user);
    }
  };

  useEffect(() => {
    if (searchData && searchData != null) {
      if (selectedCategory === "Student") {
        if (offset == 0) {
          setSuggestions([...searchData["data"]]);
        } else {
          setSuggestions((previous: any) => [
            ...previous,
            ...searchData["data"],
          ]);
        }
        setHasMore(
          searchData["data"] && searchData["data"].length > 0 ? true : false
        );
      } else {
        if (offset == 0) {
          setSuggestions([...searchData["data"]["response"]]);
        } else {
          setSuggestions((previous: any) => [
            ...previous,
            ...searchData["data"]["response"],
          ]);
        }
        setHasMore(
          searchData["data"]["response"] &&
            searchData["data"]["response"].length > 0
            ? true
            : false
        );
      }
    }
  }, [searchData]);

  const handleSetInputValue = (val: string) => {
    console.log("checking slected value", val);
    setOffSet(0);
  };
  const nextHandler = () => {
    const newOffset = offset + limit;
    setOffSet((previous) => previous + limit);
    const url = searchURL + "&limit=" + limit + "&offset=" + newOffset;
    GetSearchData(url);
  };

  const searchStudentDataHandler = (
    searchterm: any,
    moduleType: string,
    offset: number
  ) => {
    let url = `${BASE_URL + GLOBAL_SEARCH}`;
    if (hasNumbers(searchterm)) {
      url = url + `?id=${searchterm}`;
    } else {
      url = url + `?name=${searchterm}`;
    }
    url = url + "&moduleType=" + moduleType;
    setSearchURL(url);
    const newUrl = url + "&limit=" + limit + "&offset=" + offset;
    GetSearchData(newUrl);
  };

  const hasNumbers = (t: any) => {
    const regex = /\d/g;
    return regex.test(t);
  };

  const setValueHandler = (val: any) => {
    setSuggestions([]);
    setselectedItem(val);
    searchStudentDataHandler(input, val.value, 0);
    setOffSet(0);
  };
  return (
    <SearchBar
      mode={selectedCategory}
      setInputValue={(val: string) => handleSetInputValue(val)}
      setSuggestions={setSuggestions}
      suggestions={suggestions}
      isLoader={isLoader}
      setIsLoader={setIsLoader}
      searchData={(val: any) => {
        searchStudentDataHandler(val, selectedItem.value, offset);
      }}
      searchName={searchName}
      setSearchName={setSearchName}
      placeholder=""
      nextHandler={nextHandler}
      hasMore={hasMore}
      onClickHandler={onClickHandler}
      setSelectedCategory={setSelectedCategory}
      showCategories={"showCategories"}
      selectedCategory={selectedCategory}
      selectedItem={selectedItem}
      setselectedItem={(val: any) => {
        setValueHandler(val);
      }}
      onRequestClose={onRequestClose}
      input={input}
      setInput={setInput}
    />
  );
};
export default MultiSearchBar;
